//获取端口信息
function getBrowserVersion() {
 const userAgent = navigator.userAgent;
  let osName = "Unknown OS";
  let osVersion = "Unknown Version";
  // Windows
  if (userAgent.indexOf("Windows NT") !== -1) {
    osName = "Windows";
    const match = userAgent.match(/Windows NT (\d+\.\d+)/);
    if (match) {
      osVersion = match[1];
      if (osVersion === "10.0") { osVersion = "10"; }
      else if (osVersion === "6.1") { osVersion = "7"; }
      else if (osVersion === "6.2") { osVersion = "8"; }
      else if (osVersion === "6.3") { osVersion = "8.1"; }
    }
  }
  // macOS
  else if (userAgent.indexOf("Macintosh; Intel Mac OS X") !== -1) {
    osName = "macOS";
    const match = userAgent.match(/Mac OS X (\d+_\d+_\d+)/);
    if (match) {
      osVersion = match[1].replace(/_/g, '.');
    }
  }
  // Linux 由于 Linux 并没有标准的版本号，需要特殊处理，可以根据分发版进行调整
  else if (userAgent.indexOf("Linux") !== -1) {
    osName = "Linux";
  }
  // iOS
  else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    osName = "iOS";
    const match = userAgent.match(/OS (\d+_\d+_\d+) like Mac OS X/);
    if (match) {
      osVersion = match[1].replace(/_/g, '.');
    }
  }
  // Android
  else if (userAgent.indexOf("Android") !== -1) {
    osName = "Android";
    const match = userAgent.match(/Android (\d+\.\d+(\.\d+)?)/);
    if (match) {
      osVersion = match[1];
    }
  }
  return { osName: osName,osVersion: osVersion };
}
//获取IP地址
async function getVisitorCountry() {
  let response = await fetch('https://app.funny-fuzzy.com/store/country')
  let resJson = await response.json();
  return resJson.data || {}
}
//获取会话ID
function generateRandomId(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charactersLength);
        result += characters[randomIndex];
    }
    firebaseSsionFunc({ "sessionid": result })
    return result
}
//埋点存储所有的页面会话记录
function firebaseSsionFunc(params,isValue) {
    let sessionObj = sessionStorage.getItem('firebaseSsionData') ? JSON.parse(sessionStorage.getItem('firebaseSsionData')) : {};
    let sessionResult = Object.assign(sessionObj,params) 
    sessionStorage.setItem('firebaseSsionData', JSON.stringify(sessionResult));
    if(isValue){ return sessionResult }
}
function isMobile() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
// 获取安全时间戳（整数毫秒）
function getSafeTimestamp() {
  const now = Date.now();
  if (now < 1577836800000) { // 2020-01-01 00:00:00 UTC
    const fallbackTime = (performance?.timeOrigin || Date.now()) + (performance?.now() || 0);
    return Math.round(fallbackTime);
  }
  return now;
}
//自定义埋点传值信息获取
async function firebaseParams(pageName){
  let screenWidth = window.screen.width;  
  let screenHeight = window.screen.height;
   //UUID
  if(!localStorage.getItem('device_uuid')){
    let UUID = uuidv4();
    localStorage.setItem('device_uuid', UUID);
  }
  if(!localStorage.getItem('trace_id')){
    let UUID = uuidv4();
    localStorage.setItem('trace_id', UUID);
  }
  //会话ID随机32位唯一数
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  let sessionid = ssionData.sessionid || '';
  if(!ssionData.token || ssionData.pagesName.indexOf('cart') != -1){
     //获取购物车ID
    let response = await fetch(`/cart.js`);
    let responseJson = await response.json();
    let tokenObj = {
      "token": responseJson.token, 
      "currency": responseJson.currency 
    }
    let getSessionData = firebaseSsionFunc(tokenObj,true)
    ssionData = Object.assign(getSessionData,tokenObj) 
  }
  if(!ssionData.osName){
    let browserVersion = getBrowserVersion();
    let version = { 'osName':browserVersion.osName, 'osVersion': browserVersion.osVersion }
    let getSessionData = firebaseSsionFunc(version,true)
    ssionData = Object.assign(getSessionData,version) 
  }
  
  if(!ssionData.sessionid){
     sessionid = generateRandomId(32);
  }
  //登录追踪ID获取
  if(!ssionData.setCustomerCid && ssionData.isLogin){
    let UUID = uuidv4();
    localStorage.setItem('trace_id', UUID);
    firebaseSsionFunc({ 'isLogin': false })
  }
  if(ssionData.setCustomerCid){ firebaseSsionFunc({ 'isLogin': true }) }
  //获取网络IP
  if(!ssionData.ip){
    let ipInformation = await getVisitorCountry();
    let ipObecjt = { 'country':ipInformation.locationCountryName, 'ip':ipInformation.ip }
    let getSessionData = firebaseSsionFunc(ipObecjt,true)
    ssionData = Object.assign(getSessionData,ipObecjt) 
  }
  //域名链接获取，广告参数
  let href = window.location.href;
  if(href.indexOf('utm_campaign') != -1){ 
    let urlObject = new URL(href);
    let paramsObject = Object.fromEntries(urlObject.searchParams.entries());
    let params = {
      "utm_source": paramsObject.utm_source || paramsObject.tw_source || paramsObject.dm_net || '',
      "utm_medium": paramsObject.utm_medium || paramsObject.dm_medium || paramsObject.tw_medium || '',
      "utm_campaign": paramsObject.utm_campaign || paramsObject.dm_cam || paramsObject.tw_campaign || '',
      "utm_term": paramsObject.utm_term || paramsObject.dm_grp || paramsObject.tw_term || '',
      "utm_content": paramsObject.utm_content || paramsObject.dm_ad || paramsObject.tw_adid || '',
    }
    let getSessionData = firebaseSsionFunc(params,true)
    ssionData = Object.assign(getSessionData,params) 
  }
  //第一次打开页面获取
  if(!ssionData.landing_page_url){
    let getSessionData = firebaseSsionFunc({ landing_page_url: href },true)
    ssionData = Object.assign(getSessionData,{ landing_page_url: href }) 
  }
  // let platform = isMobile() ? 'wap_test': 'web_test';
  let platform = isMobile() ? 'wap': 'web';
  // 获取tid
  let tid = `${localStorage.getItem('device_uuid')}${getSafeTimestamp()}`;
  //语言获取
  let userLanguage = navigator.language || navigator.userLanguage;
  let firebaseObject = {
    "tid": tid,
    "last_tid": ssionData.last_tid || '', //上一个事件tid，如果同一个页面保持上一个事件tid，否则获取最新的上一个, 需要处理
    "user_id": ssionData.setCustomerCid ? `gid://shopify/Customer/${ssionData.setCustomerCid}` : '',
    "device_id": localStorage.getItem('device_uuid'),
    "session_id": sessionid,
    "trace_id": localStorage.getItem('trace_id'),
    "device_brand": navigator.userAgent,
    "device_model": navigator.userAgent,
    "device_os": ssionData.osName || '',
    "device_os_version": ssionData.osVersion || '',
    "device_resolution": `${screenWidth}/${screenHeight}`,
    "device_country": userLanguage.split('-')[1],
    "device_language": userLanguage,
    "device_network_type": '',
    "device_network_carrier": '',
    "device_ip": ssionData.ip || '',
    "ip_country": ssionData.country || '',
    "device_message_switch": '',
    "device_fcm_token": '',
    "bird_push_token": '',
    
    "app_country": 'Australia',
    "app_language": 'en',
    "app_currency": ssionData.currency || '',
    "site": "au",
    "platform": platform,
    "app_useragent": navigator.userAgent,
    "client_version": '1.0.2',
    "store_time_zone":"America/New_York",
    "device_time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    
    "adlink_id":"",
    "madid":"",
    "utm_source": ssionData.utm_source || '',
    "utm_medium": ssionData.utm_medium || '',
    "utm_campaign": ssionData.utm_campaign || '',
    "utm_term": ssionData.utm_term || '',
    "utm_content": ssionData.utm_content || '',

    "page_load_time": '', //页面完成加载时间，提交接口上传
    "landing_page_url": ssionData.landing_page_url,
    "url": href,
    "page_name": ssionData.pagesName,
    "url_path": href.split('//')[1],
    "last_url": document.referrer,
    "page_duration": ssionData.startTime,   //开始停留时间，接口提交时上报时间
    "page_deep": "1",  
    "reported_timestamp": '', //上报时间，接口提交时上报时间
    "event_timestamp": ssionData.startTime, //page事件进入页面时间，点击事件的传点击时间
    
    "page_position_id":"",
    "page_position_content": {},
    "last_page_position_id": "",
    "last_page_position_content":{},
    "root_page_position_id": "",
    "root_page_position_content":{},
    
    "event_name": pageName == 'page' ? `view_${ssionData.pagesName}` : 'add_to_cart',
    "track_type": pageName,
    "other_content":{},
  }
  sessionStorage.setItem('firebaseCustomerEvent', JSON.stringify([JSON.stringify(firebaseObject)]));
  if(pageName == 'page'){
     //购物车主页面
    if(ssionData.pagesName.indexOf('cart') != -1){
      let product = [];
      let page_position_content = ssionData.page_position_content || {};
      let productList = ssionData.page_position_content.items || [];
      let discount_code = '';
      let comparePriceElement = document.querySelectorAll('.line-item') || [];
      let comparePriceList = [];
      comparePriceElement.forEach((item,index)=>{
        let compare = item.querySelector('.line-item__price-list-container .price.price--compare') 
        let priceText = compare ? compare.textContent : '';
        let priceMatch = priceText.match(/(\d+\.\d{2})/);
        let price = priceMatch ? parseFloat(priceMatch[1]) : '';
        comparePriceList.push(price)
      })
      productList.forEach(async (item,index) => {
        let optionsObject = item.options_with_values.reduce((acc, option) => {
          acc[option.name] = option.value;
          return acc;
        }, {});
        if(!discount_code){
          discount_code = item.discounts.length != 0 ? item.discounts[0].title : '';
        }
        let items = {
          "product_specification": optionsObject,
          "product_id": item.product_id.toString(),
          "product_title": item.title,
          "product_img": item.image,
          "product_star": '',
          "sku_inventory": '',
          "quantity": item.quantity,
          "original_price": comparePriceList[index] ? ((comparePriceList[index]*100)/item.quantity)/100 : '',
          "price": item.price / 100,
        }
        product.push(items)
      })
      firebaseObject.page_position_content = {
        "cart_id": ssionData.token ? `gid://shopify/Cart/${ssionData.token}` : '',
        "product": product,
        "buddle_product": {},
        "product_quantity": page_position_content.item_count,
        "discount_code": discount_code,
        "subtotal_amount": page_position_content.original_total_price/100,
        "discount_amount": page_position_content.total_discount/100,
        "actual_amount": page_position_content.total_price/100,
      }
    }
    //产品详情页面
    if(ssionData.pagesName.indexOf('product_detail') != -1){
       firebaseObject.page_position_content = {
          "product_id": ssionData.page_position_content.id.toString(),
          "product_title": ssionData.page_position_content.title,
          "product_star": '',
          "product_inventory": '',
          "quantity": 1,
          "variant_id": ssionData.page_position_content.variant_id,
       }
       let variant = ssionData.page_position_content.variant_id;
       let variants = ssionData.page_position_content.variants;
       let options = ssionData.page_position_content.options || [];
       for(let i = 0; i < variants.length; i++){
          if(variants[i].id == variant){
            firebaseObject.page_position_content.original_price = (variants[i].compare_at_price/100).toString();
            firebaseObject.page_position_content.price = (variants[i].price/100).toString();
            firebaseObject.page_position_content.product_img = variants[i].featured_image.src;
            let product_specification = options.reduce((acc, name, index) => {
              acc[name] = variants[i].options[index];
              return acc;
            }, {});
            firebaseObject.page_position_content.product_specification = product_specification;
            break;
          }
       }
    }
    //系列列表
    if(ssionData.pagesName.indexOf('category_detail') != -1){
      firebaseObject.page_position_content = ssionData.page_position_content;
    }
    firebaseObject.page_position_content.is_first_load = ssionData.is_first_load ? '1':'0';
  }
  // console.log('firebaseObject==============',firebaseObject)
  return firebaseObject
}

// page页面缓存事件
async function firebaseSoon(){
  let firebaseList = JSON.parse(localStorage.getItem('firebaseSetData')) || [];
  //上个页面未执行离开页面，当前页面上报缓存事件
  if(firebaseList.length != 0){
    let storedSessionData = sessionStorage.getItem('firebaseSsionData');
    let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
    let pageList = [];
    firebaseList.forEach((item,index) => {
       item = JSON.parse(item)
       let newDateTime = getSafeTimestamp();
       item.page_duration = newDateTime - item.page_duration; //停留时间
       item.page_load_time = ssionData.page_load_time.toString() || "";
       firebaseSsionFunc({ 'last_tid': item.tid })
       item.reported_timestamp = newDateTime; //上报时间
       pageList.push(JSON.stringify(item))
    })
    localStorage.removeItem('firebaseSetData');
    let formData = { "client": "web","type": "event", "content": pageList }
    fetch(`https://app.funny-fuzzy.com/record`,{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
  }
  let firebaseParamsArry = await firebaseParams('page');
  firebaseList = [JSON.stringify(firebaseParamsArry)]
  localStorage.setItem('firebaseSetData', JSON.stringify(firebaseList));
  pageApiRuequest()
}
firebaseSoon()

async function pageApiRuequest(){
  let firebaseList = JSON.parse(localStorage.getItem('firebaseSetData')) || [];
  if(firebaseList.length == 0) return false
  let storedSessionData = sessionStorage.getItem('firebaseSsionData');
  let ssionData = storedSessionData ? JSON.parse(storedSessionData) : {};
  let pageList = [];
  firebaseList.forEach((item,index) => {
     item = JSON.parse(item)
     let newDateTime = getSafeTimestamp();
     item.page_duration = newDateTime - item.page_duration; //停留时间
     item.page_load_time = ssionData.page_load_time.toString() || "";
     if(ssionData.pagesName.indexOf('product') != -1){
        let stars = document.querySelector('.jdgm-prev-badge__stars');
        if(stars){
          let product_star = stars.getAttribute('data-score');
          item.page_position_content.product_star = product_star;
        }
      }
     firebaseSsionFunc({ 'last_tid': item.tid })
     item.reported_timestamp = newDateTime; //上报时间
     // console.log('=================',item)
     pageList.push(JSON.stringify(item))
  })
  localStorage.removeItem('firebaseSetData');
  let formData = { "client": "web","type": "event", "content": pageList }
  let response = await fetch(`https://app.funny-fuzzy.com/record`,{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  const responseJson = await response.json();
  if(!responseJson.data){ //报错获取缓存
    await firebaseCatch(responseJson,formData.content)
  }
}

//接口报错 response接口所有信息， data是为[{...}]  
async function firebaseCatch(response,data){
  if(response.status == 400) {
    localStorage.removeItem('firebaseSetData');
    return false
  }
  let firebaseList = JSON.parse(localStorage.getItem('firebaseSetData')) || [];
  if(!response.data){ //接口报错缓存接口值
     firebaseList = [...firebaseList, ...data]
     localStorage.setItem('firebaseSetData', JSON.stringify(firebaseList));
  }
}